// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b89faccc","239":"9e6fad67","455":"a5858d80"}[chunkId] + ".chunk.js";
};